export enum enumPackagesConfirmationState {
  USER_DRAFT,
  SUPPORT_DRAFT,
  USER_PACKAGES_CONFIRMED,
  UPDATED_PACKAGES_CONFIRMED,
}
